import { useAppNavigation } from '../../../hooks/useAppNavigation';

import { ReactComponent as LayoutGridIcon } from '../../../icons/layout-grid.svg';
import { ReactComponent as MealIcon } from '../../../icons/meal.svg';

import { ChoiceCard } from './ChoiceCard';
import './meal-choice.scss';

import { AdaptiveModal } from '../AdaptiveModal';

export const MealChoiceModal = () => {
  const {
    showMealChoiceModal,
    setShowMealChoiceModal,
    setShowCreateMealModal,
    setShowMealPlannerModal
  } = useAppNavigation();

  const chooseBuilder = () => {
    setShowMealChoiceModal(false);
    setShowCreateMealModal(true);
  };

  const choosePlanner = () => {
    setShowMealChoiceModal(false);
    setShowMealPlannerModal(true);
  };

  return (
    <AdaptiveModal
      open={showMealChoiceModal}
      onOpen={setShowMealChoiceModal}
      contentStyle={{ minWidth: '320px', width: '640px', maxWidth: '96vw' }}
      mobileAutoHeight
      mobilePadded
    >
      <div className="meal-choice">
        <div className="meal-choice__title">How do you want to eat?</div>
        <p className="meal-choice__subtitle">Build one meal now, or plan several days at once.</p>
        <div className="meal-choice__cards">
          <ChoiceCard
            icon={MealIcon}
            title="Build a single meal"
            description="Pick your protein, carb and veg for one meal and add it to your cart."
            timeEstimate="About 1 minute"
            popular
            onSelect={chooseBuilder}
          />
          <ChoiceCard
            icon={LayoutGridIcon}
            title="Plan my meals"
            description="Set a date range and a goal, and we'll build a full meal plan for you."
            badge="Coming soon"
            disabled
            onSelect={choosePlanner}
          />
        </div>
      </div>
    </AdaptiveModal>
  );
};
